"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2133],{

/***/ 62133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_JobOfferURLNonExistModal; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(54933);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(49929);
// EXTERNAL MODULE: ./components/shared/Button.styled.tsx
var Button_styled = __webpack_require__(59760);
// EXTERNAL MODULE: ./components/shared/HtmlTrans.tsx
var HtmlTrans = __webpack_require__(97210);
// EXTERNAL MODULE: ./components/shared/Modal.tsx
var Modal = __webpack_require__(61897);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ../../node_modules/next-i18next/dist/esm/index.js + 8 modules
var esm = __webpack_require__(7621);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-modal/lib/index.js
var lib = __webpack_require__(37149);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./utils/router.ts
var utils_router = __webpack_require__(79546);
;// CONCATENATED MODULE: ./features/job-offers/list/components/JobOfferURLNonExistModal.constants.ts
var OFFER_CANCELLED_PARAM = "offer-cancelled";

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
;// CONCATENATED MODULE: ./features/job-offers/list/components/JobOfferURLNonExistModal.styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: ",
        ";\n  text-align: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n  text-align: center;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n  text-align: center;\n  margin-bottom: ",
        ";\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: ",
        ";\n  margin-top: ",
        ";\n  justify-content: center;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var StyledIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-76233880-0"
})(_templateObject(), (0,theme/* color */.$_)("notice_500"), (0,theme/* fontSize */.JB)("xl7"));
var StyledTitle = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-76233880-1"
})(_templateObject1(), (0,theme/* fontSize */.JB)("lg"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* color */.$_)("midnight_500"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("xl3"));
var StyledText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-76233880-2"
})(_templateObject2(), (0,theme/* fontSize */.JB)("sm"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* color */.$_)("midnight_800"), (0,theme/* spacing */.W0)("xl"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* spacing */.W0)("xl3"));
var StyledActions = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-76233880-3"
})(_templateObject3(), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("ms"));

;// CONCATENATED MODULE: ./features/job-offers/list/components/JobOfferURLNonExistModal.tsx














var JobOfferURLNonExistModal = function() {
    var isOfferCancelled = function isOfferCancelled(params) {
        return params.get(OFFER_CANCELLED_PARAM) !== null && params.get(OFFER_CANCELLED_PARAM) !== "";
    };
    var closeOfferCancelledModal = function closeOfferCancelledModal() {
        setIsModalOpen(false);
    };
    var router = (0,next_router.useRouter)();
    var t = (0,useI18n/* useI18n */.Q)("job-offer-url-non-exist-modal").t;
    var ref = (0,react.useState)(false), isModalOpen = ref[0], setIsModalOpen = ref[1];
    (0,react.useEffect)(function() {
        var urlSearchParams = new URLSearchParams(window.location.search);
        if (isOfferCancelled(urlSearchParams)) {
            setIsModalOpen(true);
            setTimeout(function() {
                (0,utils_router/* removeQueryParamsFromRouter */.q)(router, [
                    OFFER_CANCELLED_PARAM
                ]);
            }, 500);
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
        isOpen: isModalOpen,
        contentLabel: t("job_offer_url_non_exist_modal.title"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIcon, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: pro_solid_svg_icons/* faTriangleExclamation */.ik8
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
                    children: t("job_offer_url_non_exist_modal.title")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledText, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                        ns: "job-offer-url-non-exist-modal",
                        i18nKey: "job_offer_url_non_exist_modal.desc",
                        components: {
                            email: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "mailto:support@getmanfred.com"
                            })
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledActions, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_styled/* default */.Z, {
                        variant: "primary",
                        id: "modal-not-go-button",
                        "aria-label": t("job_offer_url_non_exist_modal.CTA"),
                        sizes: "md",
                        onClick: function() {
                            closeOfferCancelledModal();
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            "aria-hidden": "true",
                            children: t("job_offer_url_non_exist_modal.CTA")
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var components_JobOfferURLNonExistModal = ((0,esm/* withTranslation */.Zh)([
    "job-offer-url-non-exist-modal"
])(JobOfferURLNonExistModal));


/***/ })

}]);